var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99844 0.399902C7.64217 0.399902 5.73177 2.3103 5.73177 4.66657C5.73177 7.02284 7.64217 8.93324 9.99844 8.93324C12.3547 8.93324 14.2651 7.02284 14.2651 4.66657C14.2651 2.3103 12.3547 0.399902 9.99844 0.399902ZM9.99844 2.53324C11.175 2.53324 12.1318 3.49004 12.1318 4.66657C12.1318 5.8431 11.175 6.7999 9.99844 6.7999C8.8219 6.7999 7.8651 5.8431 7.8651 4.66657C7.8651 3.49004 8.8219 2.53324 9.99844 2.53324ZM6.59635 12.552C3.59155 13.2176 0.398438 14.6772 0.398438 16.9332V19.5999H19.5984V16.9332C19.5984 14.6772 16.4053 13.2176 13.4005 12.552C12.6219 13.5877 11.3936 14.2666 9.99844 14.2666C8.60324 14.2666 7.37502 13.5877 6.59635 12.552ZM5.9276 14.9249C7.06254 15.8742 8.4859 16.3999 9.99844 16.3999C11.511 16.3999 12.9343 15.8742 14.0693 14.9249C16.4703 15.6385 17.4651 16.5994 17.4651 16.9332V17.4666H2.53177V16.9332C2.53177 16.5994 3.52654 15.6385 5.9276 14.9249Z",
    fill: "#A1A9B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysis);
export default __webpack_public_path__ + "static/media/analysis.97ddc255.svg";
export { ForwardRef as ReactComponent };